import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import postPaymentStoreOrderCardToCardTransaction from './postPaymentStoreOrderCardToCardTransaction';
import {
  ICreateStoreOrderCardToCardTransactionPayload,
  ICreateStoreOrderCardToCardTransactionResponse,
} from './types';

const usePostPaymentStoreOrderCardToCardTransaction = (
  handleAfterSuccess?: (
    data: ICreateStoreOrderCardToCardTransactionResponse,
  ) => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation<
    ICreateStoreOrderCardToCardTransactionResponse,
    AxiosError<IAxiosErr>,
    ICreateStoreOrderCardToCardTransactionPayload
  >({
    mutationFn: postPaymentStoreOrderCardToCardTransaction,
    onSuccess: data => handleAfterSuccess?.(data),
    onError: error => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostPaymentStoreOrderCardToCardTransaction;
